import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Operator } from "@/savaradio/common"
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
  upload: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value: Operator[] | null, isLoading: IsLoading } = {
  value: null, isLoading: initialLoading
}

const operatorSlice = createSlice({
  name: "operator_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Operator>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = [action.payload, ...state.value]
    },
    reset: (state, action: PayloadAction<Operator[] | null>) => {
      state.value = action.payload
    },
    merge: (state, action: PayloadAction<Operator>) => {
      if (!state.value) state.value = [action.payload]
      else state.value = state.value.map(operator => {
        if (operator._id === action.payload._id) {
          return action.payload
        }
        return operator
      })
    },
    pop: (state, action: PayloadAction<Operator>) => {
      if (state.value) state.value = state.value.filter(operator => operator._id !== action.payload._id)
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, pop, merge, setLoading } = operatorSlice.actions
export const operator_slice = operatorSlice.reducer